import MachineInspectFrontDeskList from './components/MachineInspectFrontDeskList';

export default MachineInspectFrontDeskList;
